import { Component, inject, Input, OnInit } from "@angular/core";
import { SettingsService } from "../../../../../services/settings.service";
import { ActivatedRoute, Router } from "@angular/router";
import { TableConfiguration } from "../../../../../shared/components/paginated-data-table/paginated-table-configuration.model";
import { ActionButton } from "../../../../../shared/components/paginated-data-table/action-button.model";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import { WarehouseZoneAddComponent } from "./warehouse-zone-add/warehouse-zone-add.component";
import {
  DELETE_ZONE_MUTATION,
  GET_ZONE_DATA,
  GET_ZONE_DATA_FEW_FIELDS,
} from "../../../../../store/entities/warehouse-management/building-zone/building-zone.graphql";
import { NotificationService } from "../../../../../services/notification.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../../store";
import { StoreItemActions } from "../../../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../../../store/entities/store-item/store-item.model";
import { WarehouseZone } from "../../../../../store/entities/warehouse-management/building-zone/building-zone.model";

@Component({
  selector: "app-warehouse-zone-list",
  templateUrl: "./warehouse-zone-list.component.html",
  styleUrl: "./warehouse-zone-list.component.scss",
})
export class WarehouseZoneListComponent implements OnInit {
  private settingService: SettingsService = inject(SettingsService);
  private router: Router = inject(Router);
  @Input() refresh
  upsertAction = StoreItemActions.upsertStoreItem
  deleteAction = StoreItemActions.deleteStoreItem
  query;
  filters;
  @Input() zones: any[] = [];

  addPermission: string[] = ["can_create_zone"];
  private notificationService: NotificationService =
    inject(NotificationService);

  constructor(private store: Store<AppState>, private active: ActivatedRoute) { }
  refreshDataTable: boolean = false;
  tableConfiguration: TableConfiguration = {
    tableColumns: [
      { name: "name", label: "Name" },
         { name: "numberOfBins", label: "Bins" },
            { name: "numberOfSensors", label: "Sensors" }
   
    ],
    tableCaption: "",
    showNumbers: true,
    tableNotifications: "Notification",
    showSearch: true,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: "Activate",
    empty_msg: "No data found",
  };

  actionButtons: ActionButton[] = [
    {
      id: "more",
      label: "View More",
      title: "View More",
      class: "",
      icon: "list",
      action: "more",
      confirm_first: false,
      loading_message: "",
    },
    {
      id: "edit",
      label: "Edit",
      title: "Edit",
      class: "",
      icon: "edit",
      action: "edit",
      confirm_first: false,
      loading_message: "",
    },
    {
      id: "delete",
      label: "Delete",
      title: "Delete",
      class: "",
      icon: "delete",
      action: "delete",
      confirm_first: false,
      loading_message: "",
    },
  ];

  mapFunction = (item: WarehouseZone) => {
    return {
      ...item,
    };
  };

  permissions = {
    more: ["can_view_zone"],
    edit: ["can_edit_zone"],
    delete: ["can_delete_zone"],
  };
  id
ngOnInit() {

  console.log("Snapshot queryParams:", this.active.snapshot.queryParams);

  this.active.queryParams.subscribe((qParams) => {
    console.log("Subscribed queryParams:", qParams);
  });

  this.id = this.active.snapshot.queryParams["id"];
  console.log("Warehouse ID after snapshot:", this.id);

  this.filters = {
    warehouse: this.id,
  };

  this.query = GET_ZONE_DATA_FEW_FIELDS;
}

  changeFilters(newFilters) {
    this.filters = newFilters
  }

  onAdd(data : any={}) {
     console.log("Opening dialog with warehouse ID:", this.id);
    this.settingService.openDialogModal({
      component: WarehouseZoneAddComponent,
      data: {
        ...data,
        warehouse: this.id
      },
    });
  }
  onDelete = (data) => { };

  onCustomAction(evt: any) {
    switch (evt?.action) {
      case "more":
        this.router.navigate(
          ["/manage/warehouse-management/warehouse-list/zone-view/", evt?.value?.uniqueId, this.id]
        );
        break;
      case "edit":
        this.onAdd(evt.value);
        break;
      case "delete":
        this.notificationService
          .confirmation({ message: "Are you sure you want to delete?" })
          .then((result) => {
            if (result) {
              this.store.dispatch(
                StoreItemActions.removeStoreItem({
                  entity: StoreItemEntity.zone,
                  id: evt.value.id,
                  input: { uniqueId: evt.value.uniqueId },
                  mutation: DELETE_ZONE_MUTATION,
                })
              );
            }
            else {

            }
          });
    }
  }

  protected readonly faBuilding = faBuilding;
}
